/**
 * useReducedMotion — ¿el usuario pidió reducir el movimiento?
 *
 * QUÉ HACE: expone `prefers-reduced-motion: reduce` de forma reactiva
 * reutilizando `useMatchMedia`.
 * QUÉ INVOCA: `useMatchMedia` (hooks globales).
 * QUÉ EXPORTA: useReducedMotion.
 * QUÉ NO DEBE HACER: no anima nada por sí mismo; solo informa.
 */
import { useMatchMedia } from "./useMatchMedia";

export function useReducedMotion(): boolean {
  return useMatchMedia("(prefers-reduced-motion: reduce)");
}
